<div class="small-triangle__warehouse" #smallTriangleWarehouse>
    <div class="small-triangle__warehouse-front"></div>
    <div class="small-triangle__warehouse-back"></div>
    <div class="small-triangle__warehouse-left"></div>
    <div class="small-triangle__warehouse-right"></div>
    <div class="small-triangle__warehouse-top"></div>
    <div class="small-triangle__warehouse-bottom"></div>
</div>